"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _reactNativeWeb = require("react-native-web");

var reactToNative = new Proxy(_reactNativeWeb.NativeModules.ReactToNative || {}, {
  get: function get(target, prop, receiver) {
    if (target[prop]) {
      return Reflect.get(target, prop);
    }

    console.warn("ReactToNative.".concat(prop, " native module not found"));
    return _noop2["default"];
  }
});
var nativeModules = new Proxy(_reactNativeWeb.NativeModules, {
  get: function get(target, prop, receiver) {
    if (prop === 'ReactToNative') {
      return reactToNative;
    }

    if (target[prop]) {
      return Reflect.get(target, prop);
    }

    console.warn("".concat(prop, " native module not found"));
    return _noop2["default"];
  }
});
var _default = nativeModules;
exports["default"] = _default;